module.exports = __webpack_public_path__ + "img/co-investing-5.aeae0a13.png";